__turbopack_context__.v({
  "close": "ForumIntroBanner-module-scss-module__KtXlIW__close",
  "copy": "ForumIntroBanner-module-scss-module__KtXlIW__copy",
  "iconWrapper": "ForumIntroBanner-module-scss-module__KtXlIW__iconWrapper",
  "root": "ForumIntroBanner-module-scss-module__KtXlIW__root",
});
